export const environment = {
  production: true,
  authServerUrl: "https://login-dev.warehousing.omniopti.eu/auth",
  languages: [
    {
      name: "SLO 🇸🇮",
      link: "https://sl.dashboard-dev.warehousing.omniopti.eu",
    },
    {
      name: "ENG 🇬🇧",
      link: "https://dashboard-dev.warehousing.omniopti.eu",
    },
  ],
  apiUrl: "https://api.dashboard-dev.warehousing.omniopti.eu",
};
